// require("./lib/social");
// require("./lib/ads");
// var track = require("./lib/tracking");

require("component-responsive-frame/child");
// require("./lib/social");
// require("./lib/ads");
// var track = require("./lib/tracking");

require("angular");

var app = angular.module("tax-levies", []);
var appkent = angular.module("tax-levies2", []);
var appbellevue = angular.module("tax-levies3", []);


var state = "#eec84d";
var county = "#3887c8";
var city = "#f16548";
var multi = "#5eb546";



var levyLookup = {
  "State schools": state,
  "Seattle general fund": city,
  "County government": county,
  "Seattle Park District": city,
  "Emergency Medical Service": county,
  "Port": county,
  "County flood zone": county,
  "County transportation": county,
  "County conservation": county,
  "County ferry district": county,
  "School maintenance and operation": city,
  "School construction": city,
  "Move Seattle transportation": city,
  "Families/education": city,
  "Seattle general obligation bonds": city,
  "Parks and open space": county,
   "Best Start for Kids": county,
   "Seattle House Levy": city,
   "Library services": city,
   "Preschool funding": city,
   "Emergency radio communications": county,
   "Children/Family Justice Center": county,
   "Fingerprint ID system": county,
   "Human services/veterans": county,
   "County bonds": county,
   "Campaign financing": city,
   "Sound Transit 3": multi,
   "Seattle Housing Levy": city,
   "Fingerprint ID and emergency radio": county,
   "Kent School District 415 (M&O)": city,
   "Library general obligation bond": city,
   "Kent general fund": city,
   "Library general fund": city,
   "Valley General Hospital": city,
   "Fire District 62": city,
   "Bellevue general fund": city,
   "Bellevue School District 405": city,
   "Bellevue parks/open space": city
};


var labelData = {
  "1990": "Taxes approved by state, local legislative bodies. No direct vote by public",
  "1991": "Taxes voters have approved themselves",
  "1992": "Proposed"
};


// find maximum
var max = 3500;



// taxData.forEach(function(year) {
//   var total = 0;
//   for (var levy in year) {
//     if (levy !== 'year' && levy !== 'total') {
//       total += year[levy];
//     }
//   }
//   if (total > max) max = total;
// });


var round = function(num) {
  return Math.round(num / 100000) / 10;
}

// restructure data
var data = [];

taxData.forEach(function(year) {
  var yearObj = {
    year: year.year,
    total: year.total,
    label: labelData[year.year]
  };

  yearObj.levies = [];

  for (var levy in year) {

    if (levy !== 'year' && levy !== 'total') {
      yearObj.levies.push({
        name: levy,
        number: year[levy],
        percent: year[levy] / max * 100,
        color: levyLookup[levy],
        rounded: round(year[levy])
      });
    }
  }
  data.push(yearObj);


});

var data2 = [];

taxData2.forEach(function(year) {
  var yearObj = {
    year: year.year,
    total: year.total,
    label: labelData[year.year]
  };

  yearObj.levies = [];

  for (var levy in year) {

    if (levy !== 'year' && levy !== 'total') {
      yearObj.levies.push({
        name: levy,
        number: year[levy],
        percent: year[levy] / max * 100,
        color: levyLookup[levy],
        rounded: round(year[levy])
      });
    }
  }
  data2.push(yearObj);


});

var data3 = [];

taxData3.forEach(function(year) {
  var yearObj = {
    year: year.year,
    total: year.total,
    label: labelData[year.year]
  };

  yearObj.levies = [];

  for (var levy in year) {

    if (levy !== 'year' && levy !== 'total') {
      yearObj.levies.push({
        name: levy,
        number: year[levy],
        percent: year[levy] / max * 100,
        color: levyLookup[levy],
        rounded: round(year[levy])
      });
    }
  }
  data3.push(yearObj);


});


app.controller("TaxController", ["$scope", function($scope) {
  $scope.data = data;
  $scope.max = max;
  // $scope.selected = $scope.data[0];

  $scope.showTooltip = function(obj) {
        $scope.selected = obj;
  };

  $scope.class = "selected";
  $scope.changeClass = function(){
    if ($scope.class === "selected")
      $scope.class = "";
    else
      $scope.class = "selected";
  };
}]);

appkent.controller("TaxController2", ["$scope", function($scope) {
  $scope.data = data2;
  $scope.max = max;
  // $scope.selected = $scope.data[0];

  $scope.showTooltip = function(obj) {
        $scope.selected = obj;
  };

  $scope.class = "selected";
  $scope.changeClass = function(){
    if ($scope.class === "selected")
      $scope.class = "";
    else
      $scope.class = "selected";
  };
}]);

appbellevue.controller("TaxController3", ["$scope", function($scope) {
  $scope.data = data3;
  $scope.max = max;
  // $scope.selected = $scope.data[0];

  $scope.showTooltip = function(obj) {
        $scope.selected = obj;
  };

  $scope.class = "selected";
  $scope.changeClass = function(){
    if ($scope.class === "selected")
      $scope.class = "";
    else
      $scope.class = "selected";
  };
}]);
